import React from 'react';
import { Link } from 'react-router-dom';

const Dryers = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/services" className="hover:text-accent"> Services</Link> / 
            <span className="text-gray-900"> Dryers</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Dryers</h1>
          <p className="text-xl text-gray-300">Advanced Drying Technology for Process Industries</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700 mb-6">
            ATHENA designs & manufactures various types of dryers for manufacturing Milk Powder/Fruits Powder/Baby Food powder/Coffee Powder with complete range including Spray Dryer, Fluid Bed Dryer, Vacuum Band Dryer, Vacuum Tray Dryer, Ring Dryer, Spin Flash Dryer, Rotary Dryer, and Steam Tube Dryer.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Spray Dryer</h2>
          <p className="text-gray-700 mb-6">
            Spray drying is a method of producing a dry powder from a liquid or slurry by rapidly drying with hot air. This is the transformation of liquid products into dried powders by spraying the liquid into a controlled flow of hot air within a drying chamber. Spray dried powders consist of single particles or agglomerates and the final properties of the powder depend upon the physical and chemical properties of the liquid feed together with the dryer design and operation.
          </p>
          <p className="text-gray-700 mb-6">
            Most of the drying process and particle agglomeration takes place during the first few meters after leaving the nozzles or disc atomizer. Approximately 80% of the drying process takes place here and has the greatest effect on the final product quality.
          </p>

          <h3 className="text-2xl font-bold mb-4 text-accent">ATHENA Manufactures Following Type of Spray Dryer:</h3>
          <ul className="space-y-2 feature-list mb-6">
            <li className="text-gray-700">Tower dryer/Tall form Dryer</li>
            <li className="text-gray-700">Ceiling Exhaust Dryer (MSD)</li>
            <li className="text-gray-700">Bottom Exhaust Dryer (CMD)</li>
          </ul>

          <h3 className="text-2xl font-bold mb-4 text-accent">Salient Features:</h3>
          <ul className="space-y-3 feature-list">
            <li className="text-gray-700">High Production Rate</li>
            <li className="text-gray-700">Gentle drying</li>
            <li className="text-gray-700">Short drying period</li>
            <li className="text-gray-700">Continuous operation</li>
            <li className="text-gray-700">Uniform product production</li>
            <li className="text-gray-700">Fully automatic plant</li>
            <li className="text-gray-700">High thermal efficiency</li>
            <li className="text-gray-700">Free flowing powder is required which is a unique feature of spray drying</li>
            <li className="text-gray-700">Used for the whole range of agglomerated dairy products</li>
            <li className="text-gray-700">Excellent plant performance due to the absence of any air flow obstruction</li>
          </ul>

          <h3 className="text-xl font-bold mb-3 mt-6 text-green">Application:</h3>
          <ul className="space-y-2 feature-list">
            <li className="text-gray-700">SMP/WMP/Dairy Whitener/Whey Powder</li>
            <li className="text-gray-700">Maltodextrine Powder</li>
            <li className="text-gray-700">Herbal Extract</li>
            <li className="text-gray-700">Fruit Juice Powder</li>
            <li className="text-gray-700">Instant coffee powder</li>
            <li className="text-gray-700">Egg Powder</li>
          </ul>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Fluid Bed Dryer</h2>
          <p className="text-gray-700 mb-6">
            The moist product can be put into turbulent motion using only air if moist particles are not stuck together due to moistened surface or due to thermoplasticity. Simple fluidized bed with air can be used for drying, however if particles stick together then mechanical stirrers can be used to break up the particle agglomerates for achieving stable fluidized bed.
          </p>
          <p className="text-gray-700 mb-6">
            Athena manufactures Fluid Bed dryer in various Sections i.e. 2, 3 & 4 section for optimal drying performance.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Vacuum Band Dryer</h2>
          <p className="text-gray-700 mb-6">
            Vacuum Band dryers are especially designed to provide products with a gentle thermal treatment which can be fed as a viscous liquid or paste. The band dryer comprises a vacuum chamber housing a number of conveyor bands which pass over platens heated by steam or hot water. These units are supplied with a range of capacities using single to ten band configurations.
          </p>

          <h3 className="text-xl font-bold mb-3 text-green">Application:</h3>
          <ul className="space-y-2 feature-list">
            <li className="text-gray-700">Fruit juice concentrate drying</li>
            <li className="text-gray-700">Herbal extracts drying</li>
            <li className="text-gray-700">Lumpy products & granulates drying</li>
            <li className="text-gray-700">Malted Milk Food</li>
          </ul>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Vacuum Shelf Tray Dryer</h2>
          <p className="text-gray-700 mb-6">
            Vacuum shelf/tray dryers are indirect heated batch dryers consisting of a vacuum tight chamber, a vacuum source, and a condenser. One door is provided and it is sealed with resilient gaskets of rubber or similar material.
          </p>
          <p className="text-gray-700 mb-6">
            Vacuum shelf dryers are used extensively for drying pharmaceuticals, food products, temperature sensitive or easily oxidizable materials, and materials so valuable that labor cost is insignificant. They are particularly useful for handling small batches of materials wet with toxic valuable solvents.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Ring Dryer</h2>
          <p className="text-gray-700 mb-6">
            The Ring dryer is modified version of flash dryer to improve the efficiency of pneumatic dryer with an internal classifier (manifold). Heavier material is held in airborne recycle for further circuit of drying so that the residence time is increased to 2 or 3 passes of the system.
          </p>

          <h3 className="text-xl font-bold mb-3 mt-6 text-green">Application:</h3>
          <ul className="space-y-2 feature-list">
            <li className="text-gray-700">Distillery Effluent drying</li>
            <li className="text-gray-700">Rice gluten drying</li>
            <li className="text-gray-700">Maize starch drying</li>
            <li className="text-gray-700">Fibre Starch drying</li>
            <li className="text-gray-700">Milk, Casein wheat gluten etc</li>
          </ul>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Roller Dryer</h2>
          <p className="text-gray-700 mb-6">
            Roller drying is used for liquid products which can be either low viscosity or highly viscous. Application of roller drying is in manufacturing of skim milk powder for chocolate manufacturing, Ice cream, confectionary and baby food.
          </p>
          <p className="text-gray-700 mb-6">
            Roller dryer consists of single or double Roller with or without applicator Rollers. The metal Rollers are heated from inside through condensing steam. Product dries as thin film on the cylindrical surface.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-6 section-title">Rotary Dryer</h2>
          <p className="text-gray-700 mb-6">
            The rotary dryer is a type of industrial dryer employed to reduce or minimize the liquid moisture content of the material it is handling by bringing it into direct contact with a heated gas. It shall be used in herbal extract and various other industrial applications.
          </p>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Need Custom Dryer Solutions?</h2>
          <p className="text-lg mb-6 text-gray-300">
            Our engineering team can design the perfect dryer for your specific requirements
          </p>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Dryers;